<template>
  <div>
    <desktop-header
      :org-id="orgId"
      :team-id="teamId"
      :intervals="lockTimeline ? undefined : filterIntervals"
      :selected-interval="selectedInterval"
      :show-settings="showSettings"
      :show-new-goal-button="showNewGoalButton"
      :show-new-goal-expanded="showNewGoalExpanded"
      :show-team-members="showTeamMembers"
      :show-back-button="showBackButton"
      :show-inactive-timeline-info="showInactiveTimelineInfo"
      @back="$emit('back')"
      @team-archived="$emit('team-archived')"
      @team-unarchived="$emit('team-unarchived')"
      @update:selectedInterval="$emit('update:selectedInterval', $event)"
      v-if="isDesktopMode"
    >
      <template v-slot:title>
        <slot name="title"></slot>
      </template>
    </desktop-header>
    <mobile-header
      :org-id="orgId"
      :team-id="teamId"
      :heading="heading"
      :intervals="lockTimeline ? undefined : filterIntervals"
      :selected-interval="selectedInterval"
      @update:selectedInterval="$emit('update:selectedInterval', $event)"
      v-else
    />
  </div>
</template>

<script>
import { filterIntervals } from '@/interval'
import DesktopHeader from '@/components/DesktopHeader'
import MobileHeader from '@/components/MobileHeader'
import MediaQueryMixin from '@/mixins/MediaQueryMixin'

// TODO: rename interval to timeline

/**
 * This is an abstracted component for page headers.
 * It combines DesktopHeader and MobileHeader. Visibility of the individual header component gets toggled based on the screen resolution
 */
export default {
  name: 'PageHeader',
  mixins: [MediaQueryMixin],
  props: {
    orgId: [String, Number],
    teamId: [String, Number],
    showSettings: Boolean,
    showNewGoalButton: Boolean,
    showNewGoalExpanded: Boolean, // show New Goal form in expanded view
    showTeamMembers: {
      type: Boolean,
      default: true
    },
    heading: String, // heading to be shown on mobile header
    selectedInterval: { type: Object },
    showBackButton: Boolean,
    desktopHeaderClass: String,
    lockTimeline: {
      // when locked, timeline can't be changed
      default: false
    },
    // Shows a popover when page is loaded with Inactive timeline selected
    showInactiveTimelineInfo: {
      default: false
    }
  },
  components: {
    DesktopHeader,
    MobileHeader
  },
  data() {
    return {
      filterIntervals: filterIntervals()
    }
  },
  computed: {
    team() {
      if (this.teamId) {
        return this.$store.getters.teamById(this.teamId)
      } else {
        return null
      }
    }
  }
}
</script>
